var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 25,
    viewBox: "0 0 13 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90522 24.2659V12.4082H0.940776V8.33205H3.90522V5.92344C3.90522 4.10154 4.24489 2.75828 4.92424 1.89365C5.60359 0.998145 6.86966 0.550391 8.72243 0.550391H12.7985V4.6265H9.97305C9.26282 4.6265 8.81507 4.75001 8.62979 4.99705C8.44451 5.24409 8.35188 5.6764 8.35188 6.29399V8.33205H12.7985L12.3817 12.4082H8.35188V24.2659H3.90522Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebookLogo.3e802c0e806d47f51f189ac0557f30ee.svg";
export { ForwardRef as ReactComponent };